const variables = {
    colors:{
        background: '#000',
        font: '#fff',
        link:'#d9d9d9',
        linkHover:'#fff',
    }
}
export default variables;